export default "__VITE_ASSET__BlL85MlX__"